module.exports = __webpack_public_path__ + "media/fonts/Oricons-9eb00fd2ddba7cebb8aa6db4621823e1.woff2";